export async function parseAPIErrorResponse(response: Response): Promise<string> {
  if (typeof response.text !== 'function') {
    return response.statusText;
  }

  return await response.text();
}
